export const v40_base = [
  ['P40 V40 P80 飞控', '电子件'],
  ['P40 V40 P80 水泵盒', '电子件'],
  ['V40 电调', '电子件'],
  ['V40 舵机', '电子件'],
  ['P40 V40 P80 摇摆雷达', '电子件'],
  ['2019/2020款 P40 V40 P80 地形模块', '电子件'],
  ['V40/P80 M3 M4 动力电机', '电子件'],
  ['V40 飞机-药箱端接触组件', '电子件'],
  ['P40 V40 P80 无刷喷头', '电子件'],
  ['P40 V40 蠕动泵A', '电子件'],
  ['P40 V40 蠕动泵B', '电子件'],
  ['P40 V40 P80 睿图', '电子件'],
  ['P40 V40 P80 航灯', '电子件'],
  ['P20/P30 19/20款 P40 V40 P80 UPS模块', '电子件'],
  ['21款智能药箱传感器模块（16L）', '电子件'],
  ['V40 P80 尾灯', '电子件'],
  ['P40 V40 P80 FPV相机', '电子件'],
  ['P40 V40 P80 向上雷达', '电子件'],
  ['V40 航灯&喷头-水泵板延长线', '电子件'],
  ['V40 电调-舵机Y型信号线', '电子件'],
  ['V40 RTK天线-R', '电子件'],
  ['V40 RTK天线-L', '电子件'],
  ['V40 飞机端药箱触片组件', '电子件'],
  ['V40 集线板', '电子件'],
  ['V40 蠕动泵-尾插Y型信号线', '电子件'],
  ['P40 V40 P80 探照灯', '电子件'],
  ['V40 P40 P80 4G片状天线', '电子件'],
  ['V40  WIFI天线-L', '电子件'],
  ['V40 P80料箱检测控制板组件', '电子件'],
  ['P40 V40播撒甩盘电机', '电子件'],
  ['V40 WIFI天线-R', '电子件'],
  ['V40 P80飞控-中央集线板', '电子件'],
  ['V40  WIFI天线-R', '电子件'],
  ['P40 V40播撒下料电机', '电子件'],
  ['V40播撒检测模块发射接收组件', '电子件'],
  ['P40 V40 P80 航灯-机臂连接线', '电子件'],
  ['P40 V40 P80 喷头-机臂连接线', '电子件'],
  ['V40 下料口对射灯组件', '电子件'],
  ['V40通讯电源线', '电子件'],
]
export const v40_advance: string[][] = []
